import {PickerColumn} from 'src/tracker/model/column/tracker-column'
import {bloomProperty} from 'src/tracker/model/property/equipment/misc/bloom-property'

export const bloomColumn = new PickerColumn(
  "85px",
  bloomProperty,
)
